import { render, staticRenderFns } from "./ApproveListSettingHistory.vue?vue&type=template&id=2dad7d78&scoped=true"
import script from "./ApproveListSettingHistory.vue?vue&type=script&lang=js"
export * from "./ApproveListSettingHistory.vue?vue&type=script&lang=js"
import style0 from "./ApproveListSettingHistory.vue?vue&type=style&index=0&id=2dad7d78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dad7d78",
  null
  
)

export default component.exports